/* eslint-disable import/order */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import Button from "components/Button";
import H1 from "components/H1";
import H4 from "components/H4";
import TextInput from "components/TextInput";
import organizationSvc from "services/organizationSvc";
import { useHistory } from "react-router-dom";
import Wrapper from "./Wrapper";
import Hello from "./Hello";
import authSvc from "services/authSvc";
import userSvc from "services/userSvc";

const CompanyDataFirst = () => {
  const [businessUnitName, setBusinessUnitName] = useState("");
  const [businessPhone, setBusinessPhone] = useState("");
  const [businessAddress, setBusinessAddress] = useState("");
  const [bussinessWebsiteAddress, setBusinessWebsiteAddress] = useState("");
  const [loading, setLoading] = useState(false);
  const initialError = {
    businessUnitName: "",
    businessPhone: "",
    businessAddress: "",
    bussinessWebsiteAddress: ``,
  };
  const [error, setError] = useState(initialError);
  const [currentUser, setCurrentUser] = useState();
  // const [isfullNameUser, setfullNameUser] = useState(null);
  const history = useHistory();

  // useEffect(() => {
  //   const dataUser = JSON.parse(localStorage.getItem('oca_user'))
  //   setfullNameUser(dataUser.user.fullName)
  // }, [])

  useEffect(() => {
    (async () => {
      const currUser = authSvc.currentUser();
      setCurrentUser(currUser?.user);
    })();
  }, []);

  const validation = () => {
    return true;
  };

  const handleCreate = async () => {
    setLoading(true);
    const isValidate = validation();
    if (isValidate) {
      const data = {
        business_name: businessUnitName,
        business_phone: businessPhone,
        business_address: businessAddress,
        website_url: `https://${bussinessWebsiteAddress}`,
      };

      try {
        setError("");
        const orgData = await organizationSvc.create(data);
        if (orgData?.data?.data) {
          await userSvc.update(currentUser.id, { organizationId: orgData.data.data.id });
        }
        setLoading(false);
        history.push({
          pathname: "/auth/login",
          state: { successCreateOrganization: true },
        });
      } catch (err) {
        setError(err);
        setLoading(false);
      }
    } else {
      setLoading(false);
    }
  };
  // const welcomeMessage = `Welcome, ${isfullNameUser}`;
  return (
    <div className="row mx-auto justify-content-center align-items-center flex-column ">
      <Wrapper className="d-flex flex-column">
        <Hello src={require("_assets/images/hello.png").default} className="margin-bottom-20" />

        {/* <H1 className="margin-bottom-10">
          {welcomeMessage}
        </H1> */}

        <H4 className="margin-bottom-30">
          Let’s get started! Before you start create an application, you can filll the company data
          first.
        </H4>
        <TextInput
          title="Name of business unit"
          value={businessUnitName}
          placeholder="E.g. PT Omni Communication Assistant"
          className="margin-bottom-15"
          onChange={(event) => setBusinessUnitName(event.target.value)}
          invalidFeedback={error.businessUnitName}
        />
        <TextInput
          title="No. business phone"
          value={businessPhone}
          placeholder="E.g. +123456789"
          className="margin-bottom-15"
          onChange={(event) => setBusinessPhone(event.target.value)}
          invalidFeedback={error.businessPhone}
        />
        <TextInput
          title="Business address"
          value={businessAddress}
          placeholder="E.g. Street, District, Province"
          className="margin-bottom-15"
          onChange={(event) => setBusinessAddress(event.target.value)}
          invalidFeedback={error.businessAddress}
        />
        <TextInput
          title="Website address"
          value={bussinessWebsiteAddress}
          placeholder="example.com"
          prepend="https://"
          className="margin-bottom-30"
          onChange={(event) => setBusinessWebsiteAddress(event.target.value)}
          invalidFeedback={error.bussinessWebsiteAddress}
        />
        <Button loading={loading} className="w-100" handleRoute={() => handleCreate()} primary>
          Sign up
        </Button>
      </Wrapper>
    </div>
  );
};

export default CompanyDataFirst;
